import * as React from 'react';
import { cn } from '@/hen-ui/utils';

export interface TimelineProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode | React.ReactNode[];
}

/**
 * Timeline component visualizes a chronological sequence of events.
 * Built entirely from EDU atomic components (Heading, Text, Icon) and design tokens.
 */
export const Timeline = React.forwardRef<HTMLDivElement, TimelineProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn('relative flex flex-col gap-xs', className)}
        aria-label='Timeline of events'
        {...props}
      >
        {children}
      </div>
    );
  },
);

Timeline.displayName = 'Timeline';
